import { BaseFeature } from '@core/shared/feature';
import { MEMBERSHIP_PLUGINS_TOKEN } from '@common/membership/shared';
export class MembershipPluginsLegacyBaseFeature extends BaseFeature {
  static {
    this.featureInfo = {
      context: {"package":"@pflegetheke/membership-plugins-legacy/feature","featureId":"pflegetheke-membership-plugins-legacy"},
      dependencies: ['common-membership'],
      abilityActions: false,
      providers: [{
        forPlatform: 'frontend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'PaymentFrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'frontend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'InsuranceFrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'frontend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'PrivateInsuranceFrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'admin',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'PaymentFrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'admin',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'InsuranceFrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'admin',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'PrivateInsuranceFrontendMembershipPlugin',
        importFrom: 'frontend-shared'
      }, {
        forPlatform: 'backend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'PaymentBackendMembershipPlugin',
        importFrom: 'backend-shared'
      }, {
        forPlatform: 'backend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'InsuranceBackendMembershipPlugin',
        importFrom: 'backend-shared'
      }, {
        forPlatform: 'backend',
        token: MEMBERSHIP_PLUGINS_TOKEN,
        providerName: 'PrivateInsuranceBackendMembershipPlugin',
        importFrom: 'backend-shared'
      }]
    };
  }
  getSharedDefinition() {
    return {
      routerLinkResolvers: {
        frontend: {}
      }
    };
  }
}